import { render, staticRenderFns } from "./lesson_edit.vue?vue&type=template&id=4adc5c56&scoped=true"
import script from "./lesson_edit.vue?vue&type=script&lang=js"
export * from "./lesson_edit.vue?vue&type=script&lang=js"
import style0 from "./lesson_edit.vue?vue&type=style&index=0&id=4adc5c56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc5c56",
  null
  
)

export default component.exports